import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import BookRepair from "@/pages/BookRepair";
import CallOut from "@/pages/CallOut";
import Contact from "@/pages/Contact";
import FAQ from "@/pages/FAQ";
import AreasIndex from "@/pages/AreasIndex";
import AreaPage from "@/pages/AreaPage";
import NotFound from "@/pages/NotFound";
import SiteLayout from "@/components/site/SiteLayout";
import SEO from "@/components/site/SEO";

function App() {
  return (
    <BrowserRouter>
      <SEO />
      <Routes>
        <Route element={<SiteLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/book" element={<BookRepair />} />
          <Route path="/call-out" element={<CallOut />} />
          <Route path="/areas" element={<AreasIndex />} />
          <Route path="/areas/:slug" element={<AreaPage />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
      <Toaster richColors position="top-center" />
    </BrowserRouter>
  );
}

export default App;
